import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import { moveItemInArray } from "@angular/cdk/drag-drop";
import { MenuService } from "../../../services/menu.service";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { MedicalServiceService } from "../../../services/medical-service.service";
import {
  IFilterResponse,
  SearchFilter,
} from "../../../infrastructure/iFilter-component";
import { SearchFilterComponent } from "../../search-filter/search-filter.component";
import { MedicalServiceSearchItem } from "../../../model/medical-service-search-item";
import { PatientCareTrafficLight } from "../../../model/patient/patient-care-traffic-light";
import { FilterService } from "../../../services/filter.service";
import { OtherAdmissionMedicalAppointmenDialogComponent } from "../../dialogs/other-admission-medical-appointment/other-admission-medical-appointment-dialog.component";
import { PhysicianReplacementDialogComponent } from "../../dialogs/physician-replacement/physician-replacement-dialog.component";
import { EquipmentReplacementDialogComponent } from "../../dialogs/equipment-replacement/equipment-replacement-dialog.component";
import { EquipmentFilter } from "../../../model/equipment-filter";
import { MedicalServiceWizardService } from "../../../services/wizard/medical-service/medical-service-wizard";
import { PagerControlComponent } from "../../controls/pager/pager-control.component";
import { ConfirmDialogService } from "../../../services/confirm-dialog.service";
import { MedicalAppointmenObservationDialogComponent } from "../../dialogs/medical-appointment-observation/medical-appointment-observation-dialog.component";
import { ReservationService } from "../../../services/reservation.service";
import { ReservationHisRequestDialogComponent } from "../../dialogs/reservartion-his-request-dialog/reservartion-his-request-dialog.component";

@Component({
  selector: "app-medical-service-search",
  templateUrl: "./medical-service-search.component.html",
  styleUrls: ["./medical-service-search.component.css"],
})
export class MedicalServiceSearchComponent implements OnInit, OnDestroy {
  loaded: boolean;
loadingAction: boolean;
  searchFilters: SearchFilter[];
  widthTableExp: number;
  loading: boolean;
  dataSource: MedicalServiceSearchItem[] = [];
  patientCareTrafficLights: PatientCareTrafficLight[];
  columnsDefinition: { field: string; title: string }[] = [
    { field: 'TrafficLightColor', title: '' },
    { field: 'Disability', title: 'D' },
    { field: 'ReservationHour', title: 'Hora.' },
    { field: 'ReceptionHour', title: 'Recep.' },
    { field: 'IsOverAppointment', title: 'Sobre.' },
    { field: 'Delay', title: 'Dem.' },
    { field: 'Protocol', title: 'Protocolo' },
    { field: 'PatientFullName', title: 'Paciente' },
    { field: 'PatientYearOld', title: 'Edad' },
    { field: 'PracticeRegionName', title: 'Práctica' },
    { field: 'EquipmentName', title: 'Equipo' },
    { field: 'Entity', title: 'Entidad' },
    { field: 'MedicalAppointmentStateName', title: 'Estado' },
    { field: 'ProcedureState', title: 'Estado procedimiento' },
    { field: 'Professional', title: 'Profesional' },
  ];
  columnFilters: { [field: string]: string } = {};
  sortField: string = null;
  sortAsc: boolean = true;
  columnWidths: { [field: string]: number } = {};
  hiddenColumns: Set<string> = new Set();
  dragSourceField: string = null;
  private _columnOrder: string[] = null;
  private _filteredData: MedicalServiceSearchItem[] = [];
  @ViewChild("searchFilter", { static: false })
  searchFilter: SearchFilterComponent;
  @ViewChild("pager", { static: true }) pager: PagerControlComponent;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private menuService: MenuService,
    private confirmDialogService: ConfirmDialogService,
    private medicalServiceWizardService: MedicalServiceWizardService,
    private filterService: FilterService,
    private notificationToastService: NotificationToastService,
    private medicalServiceService: MedicalServiceService
  ) {
    this.menuService.setMenuTitle("Servicio", "atención paciente");
    this.patientCareTrafficLights = [];
  }

  ngOnDestroy(): void {
    (window as any)['__medicalServiceResizeMove'] = null;
    (window as any)['__medicalServiceResizeUp'] = null;
  }

  get orderedColumnsDefinition(): { field: string; title: string }[] {
    const defaultOrder = this.columnsDefinition.map(c => c.field);
    const baseOrder = this._columnOrder != null ? this._columnOrder : defaultOrder;
    const order = baseOrder.concat(defaultOrder.filter(f => baseOrder.indexOf(f) === -1));
    const columns = order
      .map(f => this.columnsDefinition.find(c => c.field === f))
      .filter((c): c is { field: string; title: string } => c != null);
    return columns.filter(c => !this.hiddenColumns.has(c.field));
  }

  get availableColumns(): { field: string; title: string }[] {
    const defaultOrder = this.columnsDefinition.map(c => c.field);
    const baseOrder = this._columnOrder != null ? this._columnOrder : defaultOrder;
    const order = baseOrder.concat(defaultOrder.filter(f => baseOrder.indexOf(f) === -1));
    return order
      .map(f => this.columnsDefinition.find(c => c.field === f))
      .filter((c): c is { field: string; title: string } => c != null);
  }

  get exportColumns(): string[] {
    return this.orderedColumnsDefinition.map(col => col.field);
  }

  get exportColumnsName(): string[] {
    return this.orderedColumnsDefinition.map(col => col.title);
  }

  loadColumnState(): void {
    try {
      const saved = sessionStorage.getItem('medical-service-search.columns.v1');
      if (saved) {
        const parsed: { order: string[]; hidden: string[] } = JSON.parse(saved);
        this._columnOrder = parsed.order || null;
        this.hiddenColumns = new Set(parsed.hidden || []);
      }
      const savedSort = sessionStorage.getItem('medical-service-search.sort');
      if (savedSort) {
        const parsedSort: { field: string; asc: boolean } = JSON.parse(savedSort);
        this.sortField = parsedSort.field;
        this.sortAsc = parsedSort.asc;
      }
      const savedWidths = sessionStorage.getItem('medical-service-search.column-widths.v1');
      if (savedWidths) {
        this.columnWidths = JSON.parse(savedWidths);
      }
    } catch (e) {}
  }

  saveColumnState(): void {
    try {
      sessionStorage.setItem('medical-service-search.columns.v1', JSON.stringify({
        order: this._columnOrder,
        hidden: Array.from(this.hiddenColumns)
      }));
    } catch (e) {}
  }

  getColumnWidth(field: string): number {
    return this.columnWidths[field] != null ? this.columnWidths[field] : 120;
  }

  startResize(event: MouseEvent, field: string): void {
    event.preventDefault();
    const startX = event.clientX;
    const startWidth = this.getColumnWidth(field);
    const onMove = (e: MouseEvent) => {
      const newWidth = Math.max(40, startWidth + (e.clientX - startX));
      this.columnWidths = Object.assign({}, this.columnWidths, { [field]: newWidth });
    };
    const onUp = () => {
      window.removeEventListener('mousemove', (window as any)['__medicalServiceResizeMove']);
      window.removeEventListener('mouseup', (window as any)['__medicalServiceResizeUp']);
      try {
        sessionStorage.setItem('medical-service-search.column-widths.v1', JSON.stringify(this.columnWidths));
      } catch (e) {}
    };
    (window as any)['__medicalServiceResizeMove'] = onMove;
    (window as any)['__medicalServiceResizeUp'] = onUp;
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  }

  sortByColumn(field: string): void {
    if (this.sortField === field) {
      this.sortAsc = !this.sortAsc;
    } else {
      this.sortField = field;
      this.sortAsc = true;
    }
    try {
      sessionStorage.setItem('medical-service-search.sort', JSON.stringify({ field: this.sortField, asc: this.sortAsc }));
    } catch (e) {}
    this.applyColumnFilters();
  }

  getSortIcon(field: string): string {
    if (this.sortField !== field) { return 'unfold_more'; }
    return this.sortAsc ? 'arrow_upward' : 'arrow_downward';
  }

  getSortableValue(element: MedicalServiceSearchItem, field: string): any {
    if (field === 'Delay') { return element.ReceptionDate ? new Date(element.ReceptionDate).getTime() : 0; }
    if (field === 'IsOverAppointment') { return element.IsOverAppointment ? 1 : 0; }
    if (field === 'Disability') { return (element.DisabilityPermanent || element.DisabilityTemporal) ? 1 : 0; }
    return (element as any)[field];
  }

  formatCellValue(element: MedicalServiceSearchItem, field: string): string {
    if (field === 'IsOverAppointment') { return element.IsOverAppointment ? 'Sí' : 'No'; }
    if (field === 'Disability') { return (element.DisabilityPermanent || element.DisabilityTemporal) ? 'Sí' : 'No'; }
    if (field === 'TrafficLightColor' || field === 'Delay') { return ''; }
    const value = (element as any)[field];
    return String(value != null ? value : '');
  }

  onColumnFilterInput(field: string, value: string): void {
    this.columnFilters = Object.assign({}, this.columnFilters, { [field]: value });
    this.applyColumnFilters();
  }

  applyColumnFilters(): void {
    const specialFields = ['TrafficLightColor', 'Disability'];
    const dataColumns = this.columnsDefinition.map(c => c.field);
    let filtered = this._filteredData.filter(element => {
      return dataColumns.every(field => {
        if (specialFields.indexOf(field) !== -1) { return true; }
        const filterVal = (this.columnFilters[field] || '').toLowerCase().trim();
        if (!filterVal) { return true; }
        let cellVal: string;
        if (field === 'Delay') {
          cellVal = element.ReceptionHour != null ? String(element.ReceptionHour).toLowerCase() : '';
        } else {
          cellVal = this.formatCellValue(element, field).toLowerCase();
        }
        return cellVal.indexOf(filterVal) !== -1;
      });
    });
    if (this.sortField) {
      const sf = this.sortField;
      const asc = this.sortAsc;
      filtered = filtered.slice().sort((a, b) => {
        const va = this.getSortableValue(a, sf);
        const vb = this.getSortableValue(b, sf);
        if (va < vb) { return asc ? -1 : 1; }
        if (va > vb) { return asc ? 1 : -1; }
        return 0;
      });
    }
    this.pager.setItems(filtered);
  }

  onHeaderDragStart(event: DragEvent, field: string): void {
    this.dragSourceField = field;
    event.dataTransfer.effectAllowed = 'move';
  }

  onHeaderDragEnd(): void {
    this.dragSourceField = null;
  }

  onHeaderDragOver(event: DragEvent): void {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  }

  onHeaderDrop(event: DragEvent, targetField: string): void {
    event.preventDefault();
    if (this.dragSourceField == null || this.dragSourceField === targetField) { return; }
    const order = this._columnOrder != null
      ? this._columnOrder.slice()
      : this.columnsDefinition.map(c => c.field);
    const fromIndex = order.indexOf(this.dragSourceField);
    const toIndex = order.indexOf(targetField);
    if (fromIndex === -1 || toIndex === -1) { return; }
    moveItemInArray(order, fromIndex, toIndex);
    this._columnOrder = order;
    this.saveColumnState();
    this.dragSourceField = null;
  }

  isColumnVisible(field: string): boolean {
    return !this.hiddenColumns.has(field);
  }

  setColumnVisibility(field: string, visible: boolean): void {
    if (visible) {
      this.hiddenColumns.delete(field);
    } else {
      this.hiddenColumns.add(field);
    }
    this.hiddenColumns = new Set(this.hiddenColumns);
    this.saveColumnState();
  }

  showAllColumns(): void {
    this.hiddenColumns = new Set();
    this.saveColumnState();
  }

  async ngOnInit() {
    this.loadColumnState();
    try {
      this.loading = true;
      this.patientCareTrafficLights =
        await this.filterService.getPatientCareTrafficLighs();
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Atención paciente"
      );
    } finally {
      this.loading = false;
    }
  }

  onStartSearch(): void {}

  async openReservationHisRequestDialog(
    medicalServiceSearchItem: MedicalServiceSearchItem
  ) {
    this.dialog.open(ReservationHisRequestDialogComponent, {
      width: "50%",
      data: medicalServiceSearchItem.ReservationRequestHisId,
    });
  }

  openMedicalAppointmentObservationDialog(
    medicalServiceSearchItem: MedicalServiceSearchItem
  ): void {
    this.dialog.open(MedicalAppointmenObservationDialogComponent, {
      width: "50%",
      data: {
        medicalAppointmentId: medicalServiceSearchItem.MedicalAppointmentId,
      },
    });
  }

  async patientCall(medicalServiceSearchItem: MedicalServiceSearchItem) {
    try {
      await this.medicalServiceService.patientCall(
        medicalServiceSearchItem.MedicalAppointmentId
      );
      medicalServiceSearchItem.Called = true;
      this.notificationToastService.success(
        "El paciente fue llamado",
        "Atención paciente"
      );
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Atención paciente"
      );
    }
  }

  async setNextPatientCareTrafficLight(
    medicalServiceSearchItem: MedicalServiceSearchItem
  ) {
    try {
      const posiblePatientCareTrafficLights =
        this.patientCareTrafficLights.filter(
          (p) => p.ServiceId === medicalServiceSearchItem.ServiceId
        );
      const index = this.nextPatientCareTrafficLightIndex(
        medicalServiceSearchItem,
        posiblePatientCareTrafficLights
      );
      if (index > -1) {
        medicalServiceSearchItem.PatientCareTrafficLightId =
          posiblePatientCareTrafficLights[index].Id;
        await this.medicalServiceService.medicalAppointmentPatientCareTrafficLightUpdate(
          medicalServiceSearchItem
        );
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Atención paciente"
      );
    }
  }

  private nextPatientCareTrafficLightIndex(
    medicalServiceSearchItem: MedicalServiceSearchItem,
    posiblePatientCareTrafficLights: PatientCareTrafficLight[]
  ): number {
    if (posiblePatientCareTrafficLights.length > 0) {
      if (medicalServiceSearchItem.PatientCareTrafficLightId) {
        const patientCareTrafficLightIndex =
          posiblePatientCareTrafficLights.findIndex(
            (p) => p.Id === medicalServiceSearchItem.PatientCareTrafficLightId
          );
        return posiblePatientCareTrafficLights.length - 1 >
          patientCareTrafficLightIndex
          ? patientCareTrafficLightIndex + 1
          : 0;
      } else {
        return 0;
      }
    }
    return -1;
  }

  getPatientCallButtonText(
    medicalServiceSearchItem: MedicalServiceSearchItem
  ): string {
    return medicalServiceSearchItem.Called
      ? "Volver a llamar"
      : "Llamar paciente";
  }

  getPatientCareTrafficLightHtmlColor(
    medicalServiceSearchItem: MedicalServiceSearchItem
  ): string {
    if (medicalServiceSearchItem.PatientCareTrafficLightId) {
      const patientCareTrafficLight = this.patientCareTrafficLights.find(
        (p) => p.Id === medicalServiceSearchItem.PatientCareTrafficLightId
      );
      if (patientCareTrafficLight) {
        return patientCareTrafficLight.HtmlColor;
      }
    }
    return null;
  }

  getPatientCareTrafficLightCaption(
    medicalServiceSearchItem: MedicalServiceSearchItem
  ): string {
    if (medicalServiceSearchItem.PatientCareTrafficLightId) {
      const patientCareTrafficLight = this.patientCareTrafficLights.find(
        (p) => p.Id === medicalServiceSearchItem.PatientCareTrafficLightId
      );
      if (patientCareTrafficLight) {
        return patientCareTrafficLight.Caption;
      }
    }
    return null;
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = pagedItems;
    this.loading = false;
  }

  onEndSearch(response: IFilterResponse<MedicalServiceSearchItem>): void {
    this._filteredData = response.items;
    this.searchFilters = response.searchFilters;
    this.applyColumnFilters();
  }

  goMedicalOrderScann(
    medicalServiceSearchItem: MedicalServiceSearchItem
  ): void {
    this.router.navigate([
      "medical-order-scann",
      medicalServiceSearchItem.MedicalOrderId,
    ]);
  }

  openOtherMedicalAppointmentDialogDialog(
    medicalServiceSearchItem: MedicalServiceSearchItem
  ): void {
    const dialogRef = this.dialog.open(
      OtherAdmissionMedicalAppointmenDialogComponent,
      {
        width: "50%",
        data: { patientId: medicalServiceSearchItem.PatientId },
      }
    );
  }

  openPhysicianReplacementDialog(
    medicalServiceSearchItem: MedicalServiceSearchItem
  ): void {
    const dialogRef = this.dialog.open(PhysicianReplacementDialogComponent, {
      width: "50%",
      data: {
        medicalAppointmentId: medicalServiceSearchItem.MedicalAppointmentId,
      },
    });
  }

  openEquipmentReplacementDialog(
    medicalServiceSearchItem: MedicalServiceSearchItem
  ): void {
    const dialogRef = this.dialog.open(EquipmentReplacementDialogComponent, {
      width: "50%",
      data: {
        medicalAppointmentId: medicalServiceSearchItem.MedicalAppointmentId,
      },
    });

    dialogRef.afterClosed().subscribe((result: EquipmentFilter) => {
      if (result) {
        medicalServiceSearchItem.EquipmentId = result.Id;
        medicalServiceSearchItem.EquipmentName = result.Name;
      }
    });
  }

  canStartAttention(
    medicalServiceSearchItem: MedicalServiceSearchItem
  ): boolean {
    return medicalServiceSearchItem.CanStartAttention;
  }


    async view(medicalServiceSearchItem: MedicalServiceSearchItem) {
    try {


          medicalServiceSearchItem.loading = true;

          await this.medicalServiceWizardService.initialize(
            medicalServiceSearchItem, true
          );
          this.router.navigate(["/medical-service-wizard"]);


    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Atención paciente"
      );
    } finally {
      medicalServiceSearchItem.loading = false;
    }
  }



  async startAttention(medicalServiceSearchItem: MedicalServiceSearchItem) {
    try {
      if (this.canStartAttention(medicalServiceSearchItem)) {
        if (
          medicalServiceSearchItem.RequiredCallToAtention &&
          !medicalServiceSearchItem.Called
        ) {
          this.notificationToastService.info(
            "Llamado por llamador obligatorio en atención",
            "Atención paciente"
          );
        } else {
          medicalServiceSearchItem.loading = true;
          await this.medicalServiceService.medicalAppointmentCareStart(
            medicalServiceSearchItem
          );
          await this.medicalServiceWizardService.initialize(
            medicalServiceSearchItem
          );
          this.router.navigate(["/medical-service-wizard"]);
        }
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Atención paciente"
      );
    } finally {
      medicalServiceSearchItem.loading = false;
    }
  }

  rollBackAttention(medicalServiceSearchItem: MedicalServiceSearchItem) {
    this.confirmDialogService
      .confirm("Revertir", "Esta seguro que quiere revertir", "Si", "No")
      .subscribe(async (value) => {
        if (value) {
          try {
            await this.medicalServiceService.medicalAppointmentCareRollBack(
              medicalServiceSearchItem
            );
            await this.searchFilter.search();
          } catch (err) {
            this.notificationToastService.error(
              JSON.stringify(err.error),
              "Atención paciente"
            );
          }
        }
      });
  }
}
